<div class="close-container flex">
    <img src="../assets/close_icon.svg" [mat-dialog-close]="false" class="dialog-close-icon" alt="" aria-hidden="true">
</div>
<div class="flex-column">
    <h1 class="font-35 text-center-align">Add your Vehicle</h1>
    <form class="example-form" [formGroup]="addVehicleForm" (ngSubmit)="onSubmit()">
        <div class="flex">
            <div class="left-column">
                <div class="form-label">Vehicle Identification Number (VIN)
                </div>
                <mat-form-field class="full-width" appearance="outline">
                    <input matInput placeholder="Enter 17-digit VIN" formControlName="vin">
                    <mat-error *ngIf="addVehicleForm.controls['vin'].invalid && (addVehicleForm.controls['vin'].dirty || addVehicleForm.controls['vin'].touched)">
                        *Please enter valid 17 digit vin
                      </mat-error>
                </mat-form-field>
            </div>
            <div class="right-column">
                <img src="../assets/add-vin.png" height="350" alt="" aria-hidden="true">
                <p class="navy-blue-color">
                    Please look by the driver door area and find the sticker with the 17 digit VIN.
                </p>
            </div>
        </div>
        <div class="flex justify-content-center action-btn-container mt-15 ">
            <button mat-flat-button class="edit-form-button standard-btn danger-btn"  [mat-dialog-close]="false">Cancel</button>
            <button mat-flat-button class="edit-form-button standard-btn primar-btn" [disabled]="!addVehicleForm.valid">Add Vehicle</button>
        </div>
    
        
    </form>


</div>

